import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ApiModulesService} from 'src/app/api-modules.service';

@Component({
    selector: 'app-editpages',
    templateUrl: './editpages.component.html',
    styleUrls: ['./editpages.component.scss']
})
export class EditpagesComponent implements OnInit {
    countryname = [];
    language = [];
    channels = [];

    EditChannels: FormGroup;
    @Input() id = [];
    @Output() visibleParentPage: EventEmitter<any> = new EventEmitter<any>();

    constructor(private apiModulesService: ApiModulesService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
    }

    ngOnInit() {

        this.EditChannels = this.formBuilder.group({
            owned: ['', []],
            languagename: ['', []],
            countryname: ['', []]
        });


        this.editChannels();
        this.getCountriesName();
        this.getlanguage();


    }

    public getCountriesName() {
        this.apiModulesService.get('telegram/country/list').subscribe((data) => {
            this.countryname = data;
        });
    }

    public getlanguage() {
        this.apiModulesService.get('telegram/language/list').subscribe((data) => {
            this.language = data;
        });
    }

    public updatechannels() {
        const params: any = {};
        console.log(this.EditChannels);
        params.owned = this.EditChannels.value.owned;
        params.language_id = this.EditChannels.get('languagename').value;
        params.country_id = this.EditChannels.get('countryname').value;
        params.id = this.id;

        this.apiModulesService.add(params, 'telegram/channel/update_channels').subscribe((data) => {
            this.channels = data;
            //  console.log();
            this.moveToMainPage();
        });
    }

    public editChannels() {
        const params: any = {};
        params.id = this.id;
        this.apiModulesService.add(params, 'telegram/channel/edit_channels_request').subscribe((data) => {
            let channels = data;
            console.log(channels);
            this.EditChannels.setValue({
                owned: (Number)(channels.owned),
                languagename: (Number)(channels.language_id),
                countryname: (Number)(channels.country_id)
            });

            console.log(this.EditChannels.value);

        });
    }

    public moveToMainPage() {
        this.visibleParentPage.emit(true);

    }
}


